import React from 'react'
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../../components/grid-container/GridContainer"
import { UiTopBgSlider, UiTopBgSliderLeftContent, UiInnerTopBgSlider } from "../../../components/common/UiTopBgSliderElements"
import SliderHeart from "../../../../../styles/img/slider-heart-icon.png";
import UiInnerTopSliderCard from "../../../components/common/UiInnerTopSliderCard"


export default function IncentiveHomeBgSlider(props) {


    const learnMore = () => {
    }

    return (
        <>
            <UiInnerTopBgSlider>
                <UiTopBgSlider>
                    <UiCol lg="5">
                        <UiTopBgSliderLeftContent>
                            <p className='sb-top-bg-slider__slider-content__top-content'>Lorem Ipsum 432 </p>
                            <h2>Welcome <br />To
                                Campaigns<br />
                                <img src={SliderHeart} className="mx-0" /></h2>
                            <p className='sb-top-bg-slider__slider-content__description'>You’re already working hard, enjoy the benefits of
                                various rewards you, your team and your family can enjoy.</p>
                        </UiTopBgSliderLeftContent>
                    </UiCol>
                    <UiCol lg="7" className="mt-3">
                        <UiInnerTopSliderCard />
                    </UiCol>

                </UiTopBgSlider>
            </UiInnerTopBgSlider>
        </>
    )
}
